import { render, staticRenderFns } from "./BuatPasswordBaru.vue?vue&type=template&id=7d721bbf&scoped=true&"
import script from "./BuatPasswordBaru.vue?vue&type=script&lang=js&"
export * from "./BuatPasswordBaru.vue?vue&type=script&lang=js&"
import style0 from "./BuatPasswordBaru.vue?vue&type=style&index=0&id=7d721bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d721bbf",
  null
  
)

export default component.exports